export function MapLoadingOverlay() {
  return (
    <div
      className="absolute inset-0 z-50 bg-background-surface/90 backdrop-blur-sm pointer-events-none"
      data-testid="map-loading-overlay"
    >
      {/* Grid pattern to suggest map */}
      <div className="absolute inset-0 opacity-20">
        <div
          className="h-full w-full"
          style={{
            backgroundImage: `
              linear-gradient(rgba(0,0,0,0.15) 1px, transparent 1px),
              linear-gradient(90deg, rgba(0,0,0,0.15) 1px, transparent 1px)
            `,
            backgroundSize: "30px 30px",
          }}
        />
      </div>
    </div>
  );
}
